import { Country } from './app';

export interface DefaultLearningObjective {
    id: number;
    title: string;
    active: boolean;
    position: number | null;
    slides_counter: number;
    created_at: string;
    updated_at: string;
    deleted: boolean;
    ai: boolean;
    programme_position: number;
    year_id: number;
    learning_contents: LearningContents[];
}

export interface GBBasicLearningObjective extends DefaultLearningObjective {
    country: Country.GB;
    objective_type: LearningObjectiveType;
}

export interface StandardLearningObjective extends GBBasicLearningObjective {
    objective_type: LearningObjectiveType.STANDARD;
}

export interface SATsLearningObjective extends GBBasicLearningObjective {
    position: number;
    objective_type: LearningObjectiveType.SATS;
}

export interface GCSELearningObjective extends GBBasicLearningObjective {
    position: number;
    objective_type: LearningObjectiveType.GCSE;
}

export type GBLearningObjective =
    | StandardLearningObjective
    | SATsLearningObjective
    | GCSELearningObjective;

export interface USLearningObjective extends DefaultLearningObjective {
    ai: boolean;
    id: number;
    country: Country.US;
    standard_codes: string[];
    title: string;
}

export type LearningObjective = GBBasicLearningObjective | USLearningObjective;

export enum LearningObjectiveType {
    STANDARD = 'standard',
    SATS = 'sats',
    GCSE = 'gcse',
}

export interface LearningContents {
    id: number;
    title: string;
    active: boolean;
    _delete?: boolean;
}

export interface Year {
    id: number;
    name: string;
    basic_year: boolean;
}

export interface Slide {
    id: number;
    image_path: string;
    tutor_notes: string;
    position: number;
    active: boolean;
    learning_content?: LearningContents;
}
